<div class="background">

    <mat-card class="sequence-card">
        <div class="analysis-sequence-header-container">
        <div class="sequence-field-info">
            <p class="analysis-sequence-header-text">Map Sequence View</p>

            <div class="field-info-text-container">
                <span class="field-detail-title">Field Name: </span>
                <span>{{currentFieldName || '-'}}</span>
                <span> | </span>
                <span class="field-detail-title">Field Size: </span>
                <span>{{currentFieldSize ? (currentFieldSize | number: '1.2-2') : '-'}} HA</span>
            </div>
        </div>

        <div>
            <mat-slide-toggle [(ngModel)]="showLegends" (change)="toggleLegends()">Toggle Legends</mat-slide-toggle>
        </div>

            <div class="zoom-controls">
                <button class="zoom-btn" mat-icon-button (click)="zoomIn()" title="Zoom In"><img src="../../assets/icons/zoom_in.svg" alt="Add Icon" class="move-job-icon"></button>
                <button class="zoom-btn" mat-icon-button (click)="zoomOut()" title="Zoom Out"><img src="../../assets/icons/zoom_out.svg" alt="Add Icon" class="move-job-icon"></button>
                <button class="zoom-btn reset-btn" mat-icon-button (click)="resetMaps()" title="Reset Maps"><img src="../../assets/icons/reset.svg" alt="Add Icon" class="move-job-icon"></button>
            </div>

        <div class="input-container-from-date">

            <mat-form-field appearance="outline" class="form-field-sm">
                <mat-label>From Date</mat-label>
                <input  [max]="filterToDate" matInput [(ngModel)]="filterFromDate" [matDatepicker]="pickerStart" placeholder="Start date"
                    (ngModelChange)="setFilterStartDate($event)">
                <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="input-container-to-date">
            <mat-form-field appearance="outline"   class="form-field-sm">
                <mat-label>To Date</mat-label>
                <input  [min]="filterFromDate" matInput [(ngModel)]="filterToDate" [ngModelOptions]="{standalone: true}" [matDatepicker]="pickerEnd" placeholder="End date"
                    (ngModelChange)="setFilterEndDate($event)">
                <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                <mat-datepicker #pickerEnd></mat-datepicker>
            </mat-form-field>

        </div>

        <div class="input-container-type">
            <mat-form-field appearance="outline" class="form-field-sm">
                <mat-select [(value)]="analysisDefinitionId" (selectionChange)="onAnalysisTypeChange()">
                    <mat-option *ngFor="let type of analysisTypes" [value]="type?.displayOrder">
                        {{type?.alias}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="input-container-grid">
            <mat-form-field appearance="outline" class="form-field-mini">
                <mat-select [(value)]="gridSize">
                    <mat-option [value]="2">2 x row</mat-option>
                    <mat-option [value]="3">3 x row</mat-option>
                    <mat-option [value]="4">4 x row</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="input-container-pagination">
            <mat-form-field appearance="outline" class="form-field-xsm">
                <mat-select [(value)]="analysisCount" (selectionChange)="onCountChange()" [panelWidth]="null">
                    <mat-option [value]="2">2</mat-option>
                    <mat-option [value]="5">5</mat-option>
                    <mat-option [value]="10">10</mat-option>
                    <mat-option [value]="15">15</mat-option>
                    <mat-option [value]="20">20</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="input-container-close">

                <div class="close-icon-container-sequence"><img src="../../../assets/icons/close.svg" alt="Icon description"
                                                     class="close-icon-sequence" (click)="closeSequenceView()"></div>

        </div>
    </div>
    <div class="analysis-sequence-container">
        <div *ngIf="!isNoItemsFound" class="sequence-card-container"
            [style.grid-template-columns]="'repeat(' + gridSize + ', minmax(0, 1fr))'">
            <app-sequence-card *ngFor="let card of cards" [card]="card"></app-sequence-card>
        </div>

        <div *ngIf="isNoItemsFound" class="sequence-card-container">
            <div class="sequence-no-items-message-container">
                <div class="sequence-no-items-message">Sorry! No items found within the selected filter range.</div>
            </div>
        </div>
    </div>
    </mat-card>

    
</div>